import { OfficePointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (): OfficePointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.OFFICE_POINTER,
  variable: null,
});
